import React, {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {detect} from 'detect-browser'

class Symbol extends Component {
  static defaultProps = {
    className: '',
    viewBox: null,
    height: null,
    width: null,
    title: null,
    fill: null,
    margin: null,
    color: null,
    name: '',
    svgRoute: '',
    onClick: () => {}
  }

  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    fill: PropTypes.string,
    height: PropTypes.string,
    margin: PropTypes.string,
    name: PropTypes.string.isRequired,
    svgRoute: PropTypes.string.isRequired,
    title: PropTypes.string,
    viewBox: PropTypes.string,
    width: PropTypes.string,
    onClick: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.browser = detect()
  }

  render () {
    return (
      <svg
        className={this.props.className}
        color={this.props.color}
        height={this.props.height}
        style={{fill: this.props.fill, margin: this.props.margin}}
        viewBox={this.props.viewBox}
        width={this.props.width}
        onClick={this.props.onClick}
      >
        {
          this.browser && this.browser.name === 'ie'
            ? <use xlinkHref={`${this.props.svgRoute}#${this.props.name}`}>{this.props.title
              ? <title>{this.props.title}</title> : null}</use>
            : <use xlinkHref={`#${this.props.name}`}>{this.props.title ? <title>{this.props.title}</title> : null}</use>
        }
      </svg>
    )
  }
}

const mapStateToProps = state => ({
  svgRoute: state.app.svg_route
})

export default connect(
  mapStateToProps,
  null
)(Symbol)
